import { REMOVE_PARTICIPANT_FROM_SPACE } from '../../constants/endpoints';
import request from '../request';

const removeParticipantFromSpace = async ({ spaceId, userId }) => {
  const result = await request({
    method: 'DELETE',
    url: REMOVE_PARTICIPANT_FROM_SPACE(spaceId, userId),
  });
  return result;
};

export default removeParticipantFromSpace;
